import { createContext, useContext, useEffect, useState } from 'react'
import api from '../services/api'

export interface Empresa {
  empcod: number
  empnom: string
  empfan: string
  empcgc: string
  empest: string
}

interface EmpresaContextValue {
  empresas: Empresa[]
  empresaCod: number | null
  empresaAtual: Empresa | null
  setEmpresaCod: (cod: number) => void
  carregando: boolean
}

const EmpresaContext = createContext<EmpresaContextValue | null>(null)

export function EmpresaProvider({ children }: { children: React.ReactNode }) {
  const [empresas, setEmpresas] = useState<Empresa[]>([])
  const [empresaCod, setEmpresaCodState] = useState<number | null>(() => {
    const v = localStorage.getItem('frotaweb_empresa')
    return v ? Number(v) : null
  })
  const [carregando, setCarregando] = useState(true)

  useEffect(() => {
    api.get('/erp/empresas').then(r => {
      const lista: Empresa[] = r.data
      setEmpresas(lista)
      setEmpresaCodState(atual => {
        if (atual !== null && lista.some(e => e.empcod === atual)) return atual
        return lista[0]?.empcod ?? null
      })
    }).catch(() => {}).finally(() => setCarregando(false))
  }, [])

  function setEmpresaCod(cod: number) {
    localStorage.setItem('frotaweb_empresa', String(cod))
    setEmpresaCodState(cod)
  }

  const empresaAtual = empresas.find(e => e.empcod === empresaCod) ?? null

  return (
    <EmpresaContext.Provider value={{ empresas, empresaCod, empresaAtual, setEmpresaCod, carregando }}>
      {children}
    </EmpresaContext.Provider>
  )
}

export function useEmpresa(): EmpresaContextValue {
  const ctx = useContext(EmpresaContext)
  if (!ctx) throw new Error('useEmpresa deve ser usado dentro de EmpresaProvider')
  return ctx
}
